import { entriesTypes } from 'site-modules/editorial/utils/entries-types';
import { some } from 'lodash-es';

/**
 * @param {{}} entry - one of CMS entry
 * @return {Boolean} - is most common entries contain content
 */
export const checkCommonEnriesContent = entry => {
  if (entriesTypes.html.test(entry.id)) {
    const content = entry.metadata('htmlContent').value();
    return !!(content && content.length > 0);
  }
  if (entriesTypes.photo.test(entry.id)) {
    const photos = entry.links();
    return !!(photos && photos.length > 0);
  }
  if (entriesTypes.video.test(entry.id)) {
    const youtubeVideoId = entry.metadata('youtube-videoid').value();
    return !!youtubeVideoId;
  }

  return true;
};

/**
 * Checking if entry one of required type, and checking if most common entries contain content
 * NOTE: This func will filter out "editorial-high-impact" CMS entry,
 * because we disabled High-Impact dependency on CMS entries for "editorial article" pages (ADS-2018),
 * but High-Impact on "research" and "research-category" editorial pages still depends on CMS,
 * so this func should't be used for this pages
 * @param {{}} entry - one of CMS entry
 * @param {Boolean} isLegacy - is page marked as legacy
 * @return {Boolean} - is entry suitable for page
 */
export const isSuitableEntry = (entry, arrOfEntriesUsedOnPage, isLegacy) => {
  // adding !entry.id check for a temporary fix in CORE-933.  There are a many valid entries that do not
  // have ids.  The check for isEntryUsedOnPage is an exclusion list.  If the entry does not have an
  // id, then we should not be excluding it.
  const isEntryUsedOnPage = !entry.id || some(arrOfEntriesUsedOnPage, item => item.test(entry.id));

  if (isEntryUsedOnPage) {
    if (isLegacy) {
      return !!(entry.content && entry.content.length > 0);
    }

    return checkCommonEnriesContent(entry);
  }

  return false;
};
